export default "__VITE_ASSET__oiNqnFxr__"